/* global BigInt */
import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import ConnectList from './components/ConnectList';
import WalletDialog from './components/WalletDialog';
import {StoicIdentity} from './ic/identity.js';
import {  useDispatch } from 'react-redux'
import { Transform } from '@material-ui/icons';
import { useSelector } from 'react-redux'
import extjs from './ic/extjs.js';
import {principalToAccountIdentifier} from "./ic/utils"
function Mycomponents(props){
    const [open, setOpen] = React.useState(true);
    const dispatch = useDispatch()
    const init=function(type, optdata){
        
    }

    const loginbtn={
        backgroundColor:"#339999",
        width:"50px",
        color:"white",
        textAlign:"center",
        padding:"4px 10px"
    }

    const currentPrincipal = useSelector(state => state.currentPrincipal)
    const currentAccount = useSelector(state => state.currentAccount)
    const identity = useSelector(state => (state.principals.length ? state.principals[currentPrincipal].identity : {}));
    const account = useSelector(state => (state.principals.length ? state.principals[currentPrincipal].accounts[currentAccount] : {}));
    const currentToken = useSelector(state => state.currentToken);
    const [tokens, setTokens] = React.useState(account.tokens);

    const submit = (touser,amount,fee,succcallback,errcallback) => {
      //Submit to blockchain here
      var _from_principal = identity.principal;
      var _from_sa = currentAccount;
    //   var _to_user = "3731bc3fcb9fcca6870d0c85091a96d8a2ed04b2385e7f6e5aba52e8666f1d41";
        var _to_user=touser
    //    console.log(touser,amount,fee)
      var _amount = BigInt(amount*(10**8));
      var _fee = BigInt(fee*(10**8));//0.0001
      var _memo = null;
      var _notify = false;
      const id = StoicIdentity.getIdentity(identity.principal);
      if (!id) return console.log("Something wrong with your wallet, try logging in again");
      props.loader(true);
      extjs.connect("https://boundary.ic0.app/", id).token(account.tokens[currentToken].id).transfer(_from_principal, _from_sa, _to_user, _amount, _fee, _memo, _notify).then(r => {
        if (r) {
        //   return props.alert("Transaction complete", "Your transfer was sent successfully");
        succcallback(r)
        } else {
            errcallback(r)
        //   return console.log("Something went wrong with this transfer");
        }
      }).catch(e => {
          errcallback(e)
        // return console.log("There was an error: " + e);
      }).finally(() => {
        props.loader(false);
      });
    };

    var uid=""


    React.useEffect(() => {
        if(!window.getid){
            window.getid=getid
        }
        if(!window.initlogin){
            window.initlogin=function(){
                // props.handler();//授权登陆
                StoicIdentity.setup("ii").then(identity => {
                    // userid=identity.principal
                   window.alertvue(1)
                    dispatch({ type: 'createwallet', payload : {identity : identity}});
                  }).catch(e => {
                  }).finally(() => {
                    props.loader(false);
                  });
            }
        }
        if(!window.transfer){
            window.transfer=function(touser,amount,fee,succcallback,errcallback){
                submit(touser,amount,fee,succcallback,errcallback)
            }
        }
        if(!window.getaddress){
            window.getaddress=getaddress
        }
      }, []);


    const getid=function(){
        const id = identity.principal;
        console.log(id)
        if(id){
            uid=id;
            return id;
        }else{
            return false;
        }
    }

    const getaddress=function(){
        if(uid==""){
            return false;
        }
        var address = principalToAccountIdentifier(uid, 0)
        console.log(address)
        return address
    }

    const getuserid=function(){
        window.initlogin()
    }

    const usertransfer=function(){
        window.transfer("3731bc3fcb9fcca6870d0c85091a96d8a2ed04b2385e7f6e5aba52e8666f1d41",1,0.0001)
    }

   const Transform=function(){}

    return(
        <div>
            {/* <div onClick={getuserid} style={loginbtn}>登陆</div>
            <div onClick={usertransfer} style={loginbtn}>转账</div>
            <div onClick={getid} style={loginbtn}>获取id</div>
            <div onClick={getaddress} style={loginbtn}>获取地址</div> */}
        </div>
    )
}

export default Mycomponents